module.exports = __webpack_public_path__ + "img/1-1.ccf37145.svg";